import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {SlowConnectionToastData, ToastId} from '@mintdata-wsp/common/state/ui/visualDesigner/ToastData';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {when} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SlowConnectionToast.less');
const cx = classnames.bind(styles);

export interface ISlowConnectionToastProps
{
    toast:SlowConnectionToastData;
    onClose:(toastId:ToastId) => void;
    onAutoHide:(toastId:ToastId) => void;
}

@observer
export class SlowConnectionToast extends React.Component<ISlowConnectionToastProps>
{
    public componentDidMount()
    {
        const {toast, onAutoHide} = this.props;

        when(
            () => !toast.networkState.isSocketReconnecting,
            () => onAutoHide(toast.id)
        );
    }

    public render():JSX.Element
    {
        const {toast} = this.props;
        const {networkState} = toast;

        if( networkState.isNetworkTooSlowForMP )
            return this._render();
        
        return null;
    }

    private _render():JSX.Element
    {
        return (
            <div className={cx('base')}>
                <div className={cx('header')}>
                    <MDIcon name={MDIcons.common.Warning} className={cx('iconWarning')} />
                    <div className={cx('title')}>
                        {'Warning: the design may be out of sync with server'}
                    </div>
                </div>
                <div className={cx('body')}>
                    <div className={cx('message')}>
                        {'Possible reasons: either your network connection is slow/unstable, or your system is experiencing heavy load.'}<br/>
                    </div>
                </div>
                <div className={cx('footer')}>
                    <WSPButton
                        className={cx('button')}
                        style={ButtonStyle.Raised}
                        caption={'Ok, got it'}
                        onClick={this._handleCloseButtonClick}
                    />
                </div>
            </div>
        );
    }

    @bind
    private _handleCloseButtonClick()
    {
        const {toast, onClose} = this.props;

        onClose(toast.id);
    };
}
